import { createContext, useContext, useState, useCallback, ReactNode } from 'react';
import QuickEnquiryModal from '@/components/feature/QuickEnquiryModal';

interface QuickEnquiryContextValue {
  openEnquiry: (service?: string) => void;
}

const QuickEnquiryContext = createContext<QuickEnquiryContextValue>({
  openEnquiry: () => {},
});

export function QuickEnquiryProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [defaultService, setDefaultService] = useState('');

  const openEnquiry = useCallback((service = '') => {
    setDefaultService(service);
    setIsOpen(true);
  }, []);

  const closeEnquiry = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <QuickEnquiryContext.Provider value={{ openEnquiry }}>
      {children}
      <QuickEnquiryModal
        isOpen={isOpen}
        onClose={closeEnquiry}
        defaultService={defaultService}
      />
    </QuickEnquiryContext.Provider>
  );
}

export function useQuickEnquiry() {
  return useContext(QuickEnquiryContext);
}
